export default __webpack_public_path__ + "static/media/define5.993a12b3.png";